import React, { useEffect, useState } from 'react';
import Modal from 'react-responsive-modal';
import {
	Form,
	FormGroup,
	Label,
	Col,
} from 'reactstrap';
import { Post } from '../../../../function/Koneksi';

const ModalKategoriSurat = ({ data, optionData, setAlert, isOpen, setIsOpen, setStatusRefresh}) => {

	const frmDex = {
		uuid: '',
		label: '',
		nomor: '',
	}

	const initFormData = {
		status: {
			form: false,
			btnForm: false,
			btnAksi: [],
		},
		show: false,
		basicTitle: "",
		basicType: "default",
		pesanAlert: "",
	}

	const [formData, setFormData] = useState(initFormData)
	const [dt, setDt] = useState(data ? data : frmDex)
	const [draggable, setDraggable] = useState({
		isDown: false,
		startY: null,
		scrollUp: null,
	})

	useEffect(() => {
		if (document.getElementById("modalForm")) {
			document.getElementById("modalForm").reset()
		}
		
		setDt(data ? data : frmDex)
		setFormData(data ? {
			...initFormData,
			status: optionData.status,
		} : initFormData)
	}, [isOpen])


	const changeInputText = (e, fld) => {
		setDt({
			...dt,
			[fld]: e.target.value,
		})
	};

	const simpan = (e) => {
		e.preventDefault();
		setAlert({
			loadingPreview: true
		})

		let bodyRaw = {
			...dt,
		}
		
		let psn = "";
		let resstat = 204;
		let metode = "create";
		if (bodyRaw.uuid === "") {
			psn = "Tambah";
			resstat = 201;
			bodyRaw.uuid = null;
		} else {
			psn = "Ubah";
			resstat = 200;
			metode = "update";
		}
		
		Post("konfigurasi-nomor/" + metode, bodyRaw.uuid, bodyRaw,res => {
			setFormData({
				...formData,
				status: {
					...formData.status,
					btnForm: false,
					form: false,
				}
			})
			setIsOpen(false)
			if (res.status === resstat) {
				setAlert({
					loadingPreview: false
				})

				const alertData = {
					show: true,
					basicType: "success",
					basicTitle: "Data Kategori Surat",
					pesanAlert: "Berhasil " + psn + " Data",
					successAlert: true,
				}
				setAlert(alertData)
			} else if(res.status === 422) {
				setAlert({
					loadingPreview: false
				})

				const alertData = {
					show: true,
					basicType: "warning",
					basicTitle: "Data Kategori Surat",
					pesanAlert: res.data.message,
				}
				setAlert(alertData)
			} else {
				setAlert({
					loadingPreview: false
				})

				const alertData = {
					show: true,
					basicType: "danger",
					basicTitle: "Data Kategori Surat",
					pesanAlert: "Gagal " + psn + " Data"
				}
				setAlert(alertData)
			}

			// Refresh list
			setStatusRefresh(true)
		});
	};

	return (
		<Modal
			classNames={{ overlay: 'card-scrollable' }}
			open={isOpen}
			onClose={() => {
				setIsOpen(false)
			}}
			closeOnEsc={false}
			closeOnOverlayClick={true}
			styles={{ 
				modal: {
					width: '40%',
					maxWidth: 'unset',
				  }
			}}
		>
			<Form
				id="modalForm"
				data-testid="form-create"
				className="theme-form"
				onSubmit={simpan}
			>
				<div
					onMouseDown={(e) => {
						let slider = document.querySelector('.card-scrollable');
						setDraggable({
							isDown: true,
							startY: e.pageY - slider.offsetTop,
							scrollUp: slider.scrollTop,
						})
					}}
					onMouseLeave={() => {
						setDraggable({
							...draggable,
							isDown: false
						})
					}}
					onMouseUp={() => {
						setDraggable({
							...draggable,
							isDown: false
						})
					}}
					onMouseMove={(e) => {
						e.preventDefault();

						let slider = document.querySelector('.card-scrollable');

						if (!draggable.isDown) {
							return;
						}

						const y = e.pageY - slider.offsetTop;
						const startY = draggable.startY;
						const walk = y - startY;
						slider.scrollTop = draggable.scrollUp - walk;
					}}
				>
				<div className="modal-header">
					<h5 className="modal-title">{dt.uuid == '' ? 'Tambah' : 'Edit'} Kategori Surat</h5>
				</div>
				<div className="modal-body">
					<input
						className="form-control"
						id="uuid"
						type="hidden"
						placeholder=""
						defaultValue={dt.uuid}
					/>
					<FormGroup className="row">
						<Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">
							Nama Kategori Surat
						</Label>
						<Col sm="9">
							<input
								data-testid="label"
								name="label"
								className="form-control"
								id="label"
								type="text"
								placeholder="Masukkan Nama Kategori Surat"
								defaultValue={dt.label}
								onChange={e => changeInputText(e, "label")}
								required
							/>
						</Col>
					</FormGroup>
					<FormGroup className="row">
						<Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">
							Nomor Surat
						</Label>
						<Col sm="9">
							<input
								data-testid="nomor"
								name="nomor"
								className="form-control"
								id="nomor"
								type="text"
								placeholder="Masukkan Nomor Terakhir"
								defaultValue={dt.nomor}
								required
								pattern="\d{1,16}"
                        		minLength={1}
                        		maxLength={3}
								onChange={e => changeInputText(e, "nomor")}
							/>
						</Col>
					</FormGroup>
				</div>
				<div className="modal-footer">
					<button
						type="button"
						className="btn btn-warning"
						onClick={() => {
							// Tutup modal
							setFormData({
								...formData,
								status: {
									...formData.status,
									form: false,
								}
							})
							setIsOpen(false)
						}}
					>
						Tutup
					</button>
					<button
						data-testid="btnSubmitCreate"
						type="submit"
						className="btn btn-primary-custom"
						disabled={formData.status.btnForm}
					>
						Simpan
					</button>
				</div>
				</div>
			</Form>
		</Modal>
	);
}

export default ModalKategoriSurat;
